import { Header, HeaderActionBack } from "@/components/Header";
import { Layout } from "@/components/Layout";
import { Button, Image } from "antd-mobile";
import styles from "./index.module.scss";
import { useSetup } from "./logic";

export const PageQRLogin = () => {
  const logic = useSetup();

  return (
    <Layout
      backgroundImage={false}
      header={<Header title="扫码登陆" leftActions={<HeaderActionBack />} />}
    >
      {logic.QRcode ? (
        <Image className={styles.qrImage} src={logic.QRcode} />
      ) : (
        <div className={styles.qr}></div>
      )}
      <div className={styles.tip}>
        检测到新设备登录
        <br />
        请用已绑定设备的扫码授权登录
      </div>
      <Button
        className={styles.confirm}
        onClick={() => {
          logic.navigate("/unbind", { replace: true });
        }}
      >
        无法扫码？解除验证码
      </Button>
    </Layout>
  );
};
